import { useLocation } from 'react-router-dom';
import { PedidosPage } from '../../components/PedidosPage';
import ExportarPage from '../../components/ExportPage/ExportarPage';
import { sendToTerminal } from '../../lib/terminalLogger';
import { useEffect } from 'react';

/**
 * Layout CRÍTICO: Preserva estado do PedidosPage durante navegação para Export
 *
 * Strategy:
 * - PedidosPage fica SEMPRE montado (hidden com CSS quando em /exportar)
 * - Isso preserva OrderDetailsWindow state, refs, e pipeline state
 * - ExportPage renderiza sobre PedidosPage quando em /exportar
 *
 * ✅ CORREÇÃO: Renderizar AMBOS os componentes explicitamente
 * O Outlet do React Router só renderiza a rota atual, não mantém rotas anteriores
 * Por isso, precisamos renderizar PedidosPage e ExportarPage manualmente
 *
 * ATENÇÃO: Não modificar sem entender impacto no production pipeline
 */
export function PedidosExportLayout() {
  const location = useLocation();

  const isPedidos = location.pathname === '/pedidos';
  const isExport = location.pathname === '/exportar';

  // 🔍 DEBUG: Log quando a rota muda
  // useEffect(() => {
  //   sendToTerminal('🔄 [PEDIDOS_EXPORT_LAYOUT] Rota alterada', {
  //     pathname: location.pathname,
  //     isPedidos,
  //     isExport,
  //   });
  // }, [location.pathname, isPedidos, isExport]);

  return (
    <>
      {/* PedidosPage - SEMPRE montado, visibility via CSS */}
      {/* ✅ CORREÇÃO: Renderizar diretamente ao invés de usar Outlet */}
      {/* Isso garante que PedidosPage (e seu OrderDetailsWindow) NUNCA desmonta */}
      <div
        className="h-full flex flex-col"
        style={{ display: isPedidos ? 'flex' : 'none' }}
      >
        <PedidosPage />
      </div>

      {/* ExportPage - APENAS renderiza quando em /exportar */}
      {/* ✅ CORREÇÃO: Renderizar SOMENTE quando necessário */}
      {/* Não há necessidade de manter ExportarPage montado quando em /pedidos */}
      {/* Os dados de exportação são preservados no sessionStorage */}
      {isExport && (
        <div className="h-full flex flex-col">
          <ExportarPage />
        </div>
      )}
    </>
  );
}
